module.exports = __webpack_public_path__ + "static/img/iphone6.71e0c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/iphone/iphone6.png
// module id = QMUw
// module chunks = 0